import { Link } from "react-router-dom";
import "./BotonFlotante.css";

const BotonFlotante = () => {
  return <Link to="/" className="boton-flo">Cerrar</Link>;
};

export default BotonFlotante;
